import { render, staticRenderFns } from "./insurance-receipt-upload.vue?vue&type=template&id=145778d4&"
import script from "./insurance-receipt-upload.vue?vue&type=script&lang=js&"
export * from "./insurance-receipt-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports